import { AuthGuard } from '../../../../common/services/Auth.guard';
import { SmartQcComponent } from './smart-qc.component';
import { SummaryComponent } from './summary/summary.component';
import { CampaignComponent } from './campaign/campaign.component';
import { CampaignDetailComponent } from './campaign/campaign-detail/campaign-detail.component';
import { CampaignCallDetailComponent } from './campaign/call-detail/campaign-call-detail.component';
import { SettingCategoryComponent } from './setting/category/setting-category.component';
import { SettingKeywordComponent } from './setting/keyword/setting-keyword.component';
import { SettingCriteriaComponent } from './setting/criteria/setting-criteria.component';

export const SmartQcRoute = [
  {
    path: 'smart-qc',
    component: SmartQcComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'summary', pathMatch: 'full' },
      { path: 'summary', component: SummaryComponent },
      { path: 'campaigns', component: CampaignComponent },
      { path: 'campaigns/:id/calls', component: CampaignDetailComponent },
      {
        path: 'campaigns/:id/calls/:qc_ticket_id',
        component: CampaignCallDetailComponent,
      },
      {
        path: 'settings',
        canActivate: [AuthGuard],
        children: [
          { path: '', redirectTo: 'category', pathMatch: 'full' },
          { path: 'category', component: SettingCategoryComponent },
          { path: 'keyword', component: SettingKeywordComponent },
          { path: 'criteria', component: SettingCriteriaComponent },
        ],
      },
    ],
    data: { role: ['administrator', 'supervisor', 'agent'] },
  },
];



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/smart-qc/smart-qc.route.ts